/**
 * Created by sdesai on 8/12/2022
 * File: DeleteInstanceModal
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useCallback, useState } from 'react'
import {
  Button,
  LoadingIcon,
  Body
} from '@panwds/react-ui'
import { Form, SubmitButton, FormLayout, Input } from '@panwds/react-form'
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '../../../../common/components/modal/Modal'
import {
  DATA_TEST_ADD_IDENTITY_ADDRESS,
  DATA_TEST_ADD_IDENTITY_CANCEL,
  DATA_TEST_ADD_IDENTITY_SUBMIT
} from '../../../../common/constants/TestingDataIds'
import SubscriptionService from '../../../../subscription/services/SubscriptionService'
import ZIndex from '../../../../common/components/zIndex/ZIndex'
import '../../../../iam/styles/Modals.scss'
import { useFormContext, useForm } from 'react-hook-form'

const Footer = ({ isLoading, closeModal, error }) => {
  const { formState } = useFormContext()
  const { isDirty } = formState
  return (
    <ModalFooter>
      <Button
        data-testid={DATA_TEST_ADD_IDENTITY_CANCEL}
        onClick={closeModal}
        appearance="secondary"
        disabled={isLoading}
      >Cancel</Button>
      <SubmitButton
        //addClassName='dark:cm-text-red-100 cm-bg-red-500 dark:cm-bg-red-600 active:cm-bg-red-700 dark:active:cm-bg-red-400 focus-visible:cm-bg-red-600 dark:focus-visible:cm-bg-red-500 hover:cm-bg-red-600 dark:hover:cm-bg-red-500'
        appearance="primary"
        data-testid={DATA_TEST_ADD_IDENTITY_SUBMIT}
        disabled={isLoading || error || !isDirty}
      >Save</SubmitButton>
    </ModalFooter>
  )
}

const RenameInstanceModal = ({ closeModal, isOpen, instance, app, onRenameInstance }) => {
  const { trigger } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const onSubmit = useCallback(async (formValues) => {
    setIsLoading(true)
    setError('')

    try {
      await SubscriptionService.instances.patch({ tsg_id: instance.tsg_id, instance_id: instance.tenant_id, payload: formValues })
      onRenameInstance(true, instance)
      closeModal()
    }
    catch (e) {
      setError(e.message || 'An error occured during renaming the instance. Please try again.')
      onRenameInstance(false, instance, e.message || 'An error occured during activation.Please try again.')
      closeModal()
    }
    setIsLoading(false)
  }, [closeModal, instance, onRenameInstance])

  const title = `Rename ${app?.display_name}`
  const subTitle = `${instance?.tenant_instance_name} - ${instance?.tenant_id}`
  const maxLen = app?.setup?.instance_name_max_len

  return (
    <ZIndex>
      <Modal style={{ top: '30%' }} className='delete_modal' size='md' onClose={closeModal} isOpen={isOpen}>
        <Form {...{ onSubmit }} mode='onBlur'>
          <div className='header-wrapper'>
            <ModalHeader {...{ title }} {...{ subTitle }}/>
          </div>
          {isLoading ? (
            <ModalBody addClassName='tw-mr-4 tw-flex tw-flex-row tw-justify-center tw-items-center'>
              <LoadingIcon size="5xl" />
            </ModalBody>
          ) : (
            <ModalBody addClassName='tw-mr-4'>
              <FormLayout>
                <div className="tw-mt-2">
                  <Input
                    data-testid={DATA_TEST_ADD_IDENTITY_ADDRESS}
                    label='Instance Name'
                    addClassName="tw-mt-1"
                    name="tenant_instance_name"
                    placeholder='Enter New Name'
                    defaultValue={instance?.tenant_instance_name}
                    register={{
                      maxLength: {
                        value: maxLen,
                        message: `Length exceeds ${maxLen} characters.`
                      },
                      onChange: async () => await trigger('tenant_instance_name')
                    }}
                    required
                  />
                </div>
                {maxLen > 0 && <Body appearance={'secondary'}>Max length {maxLen} characters</Body>}
              </FormLayout>
            </ModalBody>
          )}
          <Footer isLoading={isLoading} error={error} closeModal={closeModal} />
        </Form>
      </Modal>
    </ZIndex>
  )
}
export default RenameInstanceModal
